"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStorageAvailable = exports.wipeStorage = exports.clearPreviousConfig = exports.setTypedStorageKey = exports.getTypedStorageKey = exports.getRecentWallets = exports.rememberWallet = void 0;
var constants_1 = require("../constants");
var MockedLocalStorage = /*#__PURE__*/function () {
  function MockedLocalStorage() {
    _classCallCheck(this, MockedLocalStorage);
    this.storage = new Map();
  }
  _createClass(MockedLocalStorage, [{
    key: "getItem",
    value: function getItem(key) {
      if (this.storage.has(key)) {
        this.storage.get(key);
      }
      return null;
    }
  }, {
    key: "key",
    value: function key(index) {
      if (index < 0 || index >= this.length) {
        return null;
      }
      var i = 0;
      var _iterator = _createForOfIteratorHelper(this.storage.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          if (i === index) {
            return value;
          }
          i += 1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.storage.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      this.storage.delete(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.storage.clear();
    }
  }, {
    key: "length",
    get: function get() {
      return this.storage.size;
    }
  }]);
  return MockedLocalStorage;
}();
var localStorage = typeof window === 'undefined' ? new MockedLocalStorage() : window.localStorage;
var MAX_WALLETS = 3;
// adds wallet to top of stack
// if stack already has wallet pull to top
function rememberWallet(type, id) {
  var unifiedID = id ? "".concat(type, ":").concat(id) : type;
  var stack = getRecentWallets();
  var index = stack.indexOf(unifiedID);
  if (index > -1) {
    stack.splice(index, 1);
  }
  var newLength = stack.unshift(unifiedID);
  if (newLength > MAX_WALLETS) {
    // remove oldest
    stack.pop();
  }
  var serialized = JSON.stringify(stack);
  localStorage.setItem(constants_1.localStorageKeys.lastUsedWallets, serialized);
}
exports.rememberWallet = rememberWallet;
function getRecentWallets() {
  var raw = localStorage.getItem(constants_1.localStorageKeys.lastUsedWallets);
  if (!raw) {
    return [];
  }
  var stack = JSON.parse(raw);
  return stack;
}
exports.getRecentWallets = getRecentWallets;
function getTypedStorageKey(key) {
  var item = localStorage.getItem(key);
  if (key === constants_1.localStorageKeys.lastUsedIndex && item) {
    return Number(item);
  }
  if (item) {
    return item;
  }
  return null;
}
exports.getTypedStorageKey = getTypedStorageKey;
function setTypedStorageKey(key, value) {
  localStorage.setItem(key, value.toString());
}
exports.setTypedStorageKey = setTypedStorageKey;
function clearPreviousConfig() {
  Object.values(constants_1.localStorageKeys).forEach(function (val) {
    if (val === constants_1.localStorageKeys.lastUsedWalletId) return;
    if (val === constants_1.localStorageKeys.lastUsedWalletType) return;
    if (val === constants_1.localStorageKeys.lastUsedWallets) return;
    localStorage.removeItem(val);
  });
}
exports.clearPreviousConfig = clearPreviousConfig;
function wipeStorage() {
  localStorage.clear();
}
exports.wipeStorage = wipeStorage;
function localStorageAvailable() {
  return typeof localStorage !== 'undefined';
}
exports.localStorageAvailable = localStorageAvailable;